import { lazy, type ComponentType } from "react";

export interface RouteConfig {
  path: string;
  label?: string;
  component: React.LazyExoticComponent<ComponentType>;
}

export const routes: RouteConfig[] = [
  {
    path: "/",
    label: "Home",
    component: lazy(() => import("@/pages/HomePage")),
  },
  {
    path: "/services",
    label: "Services",
    component: lazy(() => import("@/pages/ServicesPage")),
  },
  {
    path: "/about",
    label: "About",
    component: lazy(() => import("@/pages/AboutPage")),
  },
  {
    path: "/contact",
    label: "Contact",
    component: lazy(() => import("@/pages/ContactPage")),
  },
  {
    path: "*",
    component: lazy(() => import("@/pages/NotFoundPage")),
  },
];

export const navLinks = routes.filter(
  (r): r is RouteConfig & { label: string } => !!r.label,
);
